import * as React from 'react';

const Angle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 15.8333H2.5L10 3.33331M17.1792 12.6425H17.1917M16.2625 9.80915H16.275M14.7625 7.22581H14.775M12.8458 4.97581H12.8583" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default Angle;
